import { create } from 'zustand';
import { familyInfo } from 'src/static/sample/stepA';
import _ from 'lodash';

interface stepDataState {
  result: { data: any };
  bind: (result: { data: any }) => void;
}
interface familyInitDataState {
  param: any;
  bindParam: any;
  result: any;
  payload: any;
  initPayload: any;
  bind: (result: { data: any }) => void;
  bindPayload: (payload: { data: any }) => void;
}

export const initPayload = {
  is_deduct_single_parent: '', //한부모공제여부
  co_id: '', //사번
  family_seqid: 0, //family_seqid
  family_cd: '', //가족코드
  family_type: '1', //가족유형
  is_hc_exception: 'N', //건강보험산정특례자 여부
  is_deduct_women: 'N', //부녀자공제여부
  child_cd: '0', //자녀구분
  is_ele_deduct: 'N', //기본공제여부
  res_id: '', //주민번호
  is_foreign: 'N', //외국인여부
  name: '', //부양가족이름
  is_incom: 'N', //소득요건
  is_adopt: 'N', //입양여부
  adopt_date: '', //입양일자
  is_handy: '0', //장애인여부
  acct_year: '', //연말정산 년도
  co_cd: '', //회사코드
};

/**
  부양가족 상태관리
**/
export const familyDataStore = create<familyInitDataState>(set => ({
  param: { initialSeq: 0 },
  bindParam: (bind: any) =>
    set(state => ({
      ...state,
      param: { ...state.param, ...bind },
    })),
  result: familyInfo.init,
  bind: (data: any) =>
    set(state => ({
      ...state,
      result: { ...state.result, ...data },
    })),
  initPayload: familyInfo.init,
  payload: _.cloneDeep(familyInfo.init),
  bindPayload: (data: any) =>
    set(state => ({
      ...state,
      payload: { ...state.payload, ...data },
    })),
}));

export const familyInfoDataStore = create<stepDataState>(set => ({
  result: { data: null },
  bind: (data: any) =>
    set(state => ({
      ...state,
      result: { ...state.result, ...data },
    })),
}));

/**
  subMenu 상태관리
**/
export const familyInitDataStore = create<familyInitDataState>(set => ({
  param: {},
  bindParam: (bind: any) =>
    set(state => ({
      ...state,
      param: { ...state.param, ...bind },
    })),
  result: familyInfo.init,
  initPayload: { data: null },
  payload: { data: null },
  bind: (data: any) =>
    set(state => ({
      ...state,
      result: { ...state.payload, ...data },
    })),
  bindPayload: (data: any) =>
    set(state => ({
      ...state,
      result: { ...state.payload, ...data },
    })),
}));
